import { EnquiriesScreen, EnquiriesScreenProps, EnquiryHandle } from '@access-erp/common';
import { forwardRefGeneric } from '@access-erp/ui-components';
import { JSX, MutableRefObject, Ref } from 'react';

import { ExportProvider } from './ExportProvider';
import { SavedSearchesProvider } from './SavedSearchesProvider';
import { Forms } from '@/graphql/contracts/_generated_/contracts';

export const ContractsEnquiriesScreen = forwardRefGeneric(
  <TData extends { id: string | number }, TDetailData extends { id: string | number }>(
    props: EnquiriesScreenProps<TData, TDetailData, Forms>,
    ref: MutableRefObject<EnquiryHandle<TData>> | Ref<EnquiryHandle<TData>>,
  ): JSX.Element => {

    return (
      <SavedSearchesProvider>
        <ExportProvider>
          <EnquiriesScreen {...props} ref={ref} />
        </ExportProvider>
      </SavedSearchesProvider>
    );
  },
);
